export enum EIndicatorSource {
  DROPDOWN = 'DROPDOWN',
  CONTEXT_MENU = 'CONTEXT_MENU'
}

export enum EDataTestIdPrefix {
  EDIT = 'EDIT',
  TRADE = 'TRADE',
  EDIT_CONFIRMATION = 'EDIT_CONFIRMATION',
  TRADE_CONFIRMATION = 'TRADE_CONFIRMATION',
  SPECIFICATION = 'SPECIFICATION',
  DROPDOWN_CHART_SETTING = 'DROPDOWN_CHART_SETTING',
  CONTEXT_MENU_CHART_SETTING = 'CONTEXT_MENU_CHART_SETTING',
  CHART_INDICATOR = 'CHART_INDICATOR',
  EDIT_INPUT_EXPIRY_DATE = 'EDIT_INPUT_EXPIRY_DATE',
  TRADE_INPUT_EXPIRY_DATE = 'TRADE_INPUT_EXPIRY_DATE',
  EDIT_INPUT_EXPIRY_TIME = 'EDIT_INPUT_EXPIRY_TIME',
  TRADE_INPUT_EXPIRY_TIME = 'TRADE_INPUT_EXPIRY_TIME',
  TOP_PICKS = 'TOP_PICKS',
  TOP_GAINER = 'TOP_GAINER',
  TOP_LOSER = 'TOP_LOSER',
  WATCHLIST = 'WATCHLIST'
}

export enum EDataTestIdSuffix {
  LABEL = 'LABEL',
  VALUE = 'VALUE',
  SYMBOL = 'SYMBOL',
  ORDER_TYPE = 'ORDER_TYPE',
  ORDER_ID = 'ORDER_ID',
  VOLUME = 'VOLUME',
  BUTTON_CONFIRM = 'BUTTON_CONFIRM',
  BUTTON_CLOSE = 'BUTTON_CLOSE',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  SECOND = 'SECOND',
  CHART_COLOR_SETTING = 'CHART_COLOR_SETTING',
  DROPDOWN_FILL_POLICY = 'DROPDOWN_FILL_POLICY',
  DROPDOWN_EXPIRY = 'DROPDOWN_EXPIRY',
  DROPDOWN_DEVIATION = 'DROPDOWN_DEVIATION',
  REMOVE_ALL_DRAWING = 'REMOVE_ALL_DRAWING',
  REMOVE_ALL_INDICATORS = 'REMOVE_ALL_INDICATORS',
  RESET_CHART = 'RESET_CHART',
  HIDE_ASK_PRICE_ON_Y_AXIS = 'HIDE_ASK_PRICE_ON_Y_AXIS',
  SHOW_ASK_PRICE_ON_Y_AXIS = 'SHOW_ASK_PRICE_ON_Y_AXIS',
  CLEAR_ALL_TRACK_DETAILS = 'CLEAR_ALL_TRACK_DETAILS',
  REMOVE_ALL_INDICATORS_AND_DRAWINGS = 'REMOVE_ALL_INDICATORS_AND_DRAWINGS',
  ONE_POINT_EQUAL_LABEL = 'ONE_POINT_EQUAL_LABEL',
  MODAL = 'MODAL',

  MARKET = 'MARKET',
  LIMIT = 'LIMIT',
  STOP = 'STOP',
  STOP_LIMIT = 'STOP_LIMIT',

  GTC = 'GOOD_TILL_CANCELLED',
  GTD = 'GOOD_TILL_DAY',
  DAY = 'DAY',
  SPECIFIED_DATE = 'SPECIFIED_DATE',
  SPECIFIED_TIMESTAMP = 'SPECIFIED_DATE_AND_TIME',

  FOK = 'FILL_OR_KILL',
  IOC = 'IMMEDIATE_OR_CANCEL',
  RETURN = 'RETURN',

  CLOSE = 'CLOSE',
  TITLE = 'TITLE',
  DESCRIPTION = 'DESCRIPTION',

  INCREASE = 'increase',
  DECREASE = 'decrease',
  STATIC_MIN = 'static-min',
  STATIC_MAX = 'static-max',
  MAX_VALUE = 'max-value'
}

export enum EPricePointsDataTestIdPrefix {
  EDIT_INPUT_STOPLOSS = 'EDIT_INPUT_STOPLOSS',
  EDIT_INPUT_TAKEPROFIT = 'EDIT_INPUT_TAKEPROFIT',
  TRADE_INPUT_TAKEPROFIT = 'TRADE_INPUT_TAKEPROFIT',
  TRADE_INPUT_STOPLOSS = 'TRADE_INPUT_STOPLOSS'
}

export enum EDataTestId {
  APP_SETTING_DROPDOWN_TRIGGER = 'app-setting-dropdown-trigger',
  ASSET_ACCOUNT_INFO_ID = 'asset-account-info-id',
  ASSET_ACCOUNT_INFO_LEVERAGE = 'asset-account-info-leverage',
  ASSET_ACCOUNT_INFO_BALANCE = 'asset-account-info-balance',
  ASSET_ACCOUNT_INFO_PNL = 'asset-account-info-pnl',
  ASSET_ACCOUNT_INFO_BUYING_POWER = 'asset-account-info-buying-power',
  ASSET_ACCOUNT_INFO_CREDIT = 'asset-account-info-credit',
  ASSET_ACCOUNT_INFO_DEPOSIT = 'asset-account-info-deposit',
  ASSET_ACCOUNT_INFO_WITHDRAWAL = 'asset-account-info-withdrawal',
  ASSET_AVAILABLE_BALANCE_TITLE = 'available-balance-label',
  ASSET_AVAILABLE_BALANCE_VALUE = 'available-balance-value',
  ASSET_DETAILED_HEADER_SYMBOL = 'asset-detailed-header-symbol',

  ASSET_HISTORY = 'asset-history',
  ASSET_HISTORY_COLUMN_CLOSE_DATE = 'asset-history-column-close-date',
  ASSET_HISTORY_COLUMN_CLOSE_PRICE = 'asset-history-column-close-price',
  ASSET_HISTORY_COLUMN_COMMISSION = 'asset-history-column-commission',
  ASSET_HISTORY_COLUMN_ENTRY_PRICE = 'asset-history-column-entry-price',
  ASSET_HISTORY_COLUMN_OPEN_DATE = 'asset-history-column-open-date',
  ASSET_HISTORY_COLUMN_SYMBOL = 'asset-history-column-symbol',
  ASSET_HISTORY_COLUMN_ORDER_ID = 'asset-history-column-order-id',
  ASSET_HISTORY_COLUMN_ORDER_TYPE = 'asset-history-column-order-type',
  ASSET_HISTORY_COLUMN_PROFIT = 'asset-history-column-profit',
  ASSET_HISTORY_COLUMN_REMARKS = 'asset-history-column-remarks',
  ASSET_HISTORY_COLUMN_SIZE = 'asset-history-column-size',
  ASSET_HISTORY_COLUMN_STATUS = 'asset-history-column-status',
  ASSET_HISTORY_COLUMN_STOP_LOSS = 'asset-history-column-stop-loss',
  ASSET_HISTORY_COLUMN_SWAP = 'asset-history-column-swap',
  ASSET_HISTORY_COLUMN_TAKE_PROFIT = 'asset-history-column-take-profit',
  ASSET_HISTORY_COLUMN_UNITS = 'asset-history-column-units',
  ASSET_HISTORY_COLUMN_VOLUME = 'asset-history-column-volume',
  ASSET_HISTORY_COLUMN_STATE = 'asset-history-column-state',
  ASSET_HISTORY_COLUMN_FILL_POLICY = 'asset-history-column-fill-policy',
  ASSET_HISTORY_COLUMN_TICKET = 'asset-history-column-ticket',
  ASSET_HISTORY_COLUMN_CURRENCY = 'asset-history-column-currency',
  ASSET_HISTORY_COLUMN_CLOSED_TRANSACTION_TYPE = 'asset-history-column-closed-transaction-type',
  ASSET_HISTORY_COLUMN_OPEN_CENTROID_ORDER_ID = 'asset-history-column-open-centroid-order-id',
  ASSET_HISTORY_COLUMN_CLOSE_CENTROID_ORDER_ID = 'asset-history-column-close-centroid-order-id',
  ASSET_HISTORY_COLUMN_NOTIONAL = 'asset-history-column-notional',
  ASSET_HISTORY_COLUMN_AVG_FILLED_PRICE = 'asset-history-column-avg-filled-price',
  ASSET_HISTORY_COLUMN_PRICE = 'asset-history-column-price',
  ASSET_HISTORY_COLUMN_FILL_VOLUME = 'asset-history-column-fill-volume',
  ASSET_HISTORY_COLUMN_VALIDITY = 'asset-history-column-validity',
  ASSET_HISTORY_COLUMN_UPDATED_DATE = 'asset-history-column-updated-date',
  ASSET_HISTORY_COLUMN_CREATED_DATE = 'asset-history-column-created-date',
  ASSET_HISTORY_COLUMN_ORDER_STATUS = 'asset-history-column-order-status',
  ASSET_HISTORY_COLUMN_SYMBOL_NAME = 'asset-history-column-symbol-name',
  ASSET_HISTORY_COLUMN_PLACED_QUANTITY = 'asset-history-column-placed-quantity',
  ASSET_HISTORY_COLUMN_FILLED_QUANTITY = 'asset-history-column-filled-quantity',
  ASSET_HISTORY_COLUMN_REMAINING_QUANTITY = 'asset-history-column-remaining-quantity',
  ASSET_HISTORY_COLUMN_STOP_PRICE = 'asset-history-column-stop-price',
  ASSET_HISTORY_COLUMN_LIMIT_PRICE = 'asset-history-column-limit-price',
  ASSET_HISTORY_COLUMN_TIME_IN_FORCE = 'asset-history-column-time-in-force',
  ASSET_HISTORY_COLUMN_EXPIRY_DATE = 'asset-history-column-expiry-date',
  ASSET_HISTORY_POSITION_TABLE = 'asset-history-position-table',
  ASSET_HISTORY_POSITION_TABLE_HEADER = 'asset-history-position-table-header',
  ASSET_HISTORY_POSITION_LIST = 'asset-history-position-list',
  ASSET_HISTORY_POSITION_LIST_ITEM = 'asset-history-position-list-item',
  ASSET_HISTORY_POSITION_LIST_ITEM_EXPAND = 'asset-history-position-list-item-expand',

  ASSET_HISTORY_ORDER_DEAL = 'asset-history-order-deal',
  ASSET_HISTORY_ORDER_DEAL_TABLE = 'asset-history-order-deal-table',
  ASSET_HISTORY_ORDER_DEAL_TABLE_HEADER = 'asset-history-order-deal-table-header',
  ASSET_HISTORY_ORDER_DEAL_LIST = 'asset-history-order-deal-list',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_CLOSE_DATE = 'asset-history-order-deal-column-close-date',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_CLOSE_PRICE = 'asset-history-order-deal-column-close-price',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_COMMISSION = 'asset-history-order-deal-column-commission',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_ENTRY_PRICE = 'asset-history-order-deal-column-entry-price',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_OPEN_DATE = 'asset-history-order-deal-column-open-date',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_ORDER_ID = 'asset-history-order-deal-column-order-id',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_ORDER_TYPE = 'asset-history-order-deal-column-order-type',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_PROFIT = 'asset-history-order-deal-column-profit',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_REMARKS = 'asset-history-order-deal-column-remarks',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_SIZE = 'asset-history-order-deal-column-size',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_STATUS = 'asset-history-order-deal-column-status',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_STOP_LOSS = 'asset-history-order-deal-column-stop-loss',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_SWAP = 'asset-history-order-deal-column-swap',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_TAKE_PROFIT = 'asset-history-order-deal-column-take-profit',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_UNITS = 'asset-history-order-deal-column-units',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_FILL_POLICY = 'asset-history-order-deal-column-fill-policy',

  ASSET_OPEN = 'asset-open',
  ASSET_OPEN_BUTTON_CLOSE = 'asset-open-button-close',
  ASSET_OPEN_BUTTON_EDIT = 'asset-open-button-edit',
  ASSET_OPEN_BUTTON_TRACK = 'asset-open-button-track',
  ASSET_OPEN_COLUMN_AVG_BOUGHT_PRICE = 'asset-open-column-avg-bought-price',
  ASSET_OPEN_COLUMN_AVG_SOLD_PRICE = 'asset-open-column-avg-sold-price',
  ASSET_OPEN_COLUMN_COMMISSION = 'asset-open-column-commission',
  ASSET_OPEN_COLUMN_CURRENT_PRICE = 'asset-open-column-current-price',
  ASSET_OPEN_COLUMN_ENTRY_PRICE = 'asset-open-column-entry-price',
  ASSET_OPEN_COLUMN_OPEN_DATE = 'asset-open-column-open-date',
  ASSET_OPEN_COLUMN_SYMBOL = 'asset-open-column-symbol',
  ASSET_OPEN_COLUMN_ORDER_ID = 'asset-open-column-order-id',
  ASSET_OPEN_COLUMN_ORDER_TYPE = 'asset-open-column-order-type',
  ASSET_OPEN_COLUMN_PROFIT = 'asset-open-column-profit',
  ASSET_OPEN_COLUMN_STOP_LOSS = 'asset-open-column-stop-loss',
  ASSET_OPEN_COLUMN_STOP_LOSS_IN_POINTS = 'asset-open-column-stop-loss-in-points',
  ASSET_OPEN_COLUMN_POTENTIAL_LOSS = 'asset-open-column-potential-loss',
  ASSET_OPEN_COLUMN_POTENTIAL_GAIN = 'asset-open-column-potential-gain',
  ASSET_OPEN_COLUMN_RISK_REWARD = 'asset-open-column-risk-reward',
  ASSET_OPEN_COLUMN_MARGIN_USED = 'asset-open-column-margin-used',
  ASSET_OPEN_COLUMN_MARKET_VALUE = 'asset-open-column-market-value',
  ASSET_OPEN_COLUMN_SWAP = 'asset-open-column-swap',
  ASSET_OPEN_COLUMN_TAKE_PROFIT = 'asset-open-column-take-profit',
  ASSET_OPEN_COLUMN_UNITS = 'asset-open-column-units',
  ASSET_OPEN_COLUMN_VOLUME = 'asset-open-column-volume',
  ASSET_OPEN_TABLE = 'asset-open-table',
  ASSET_OPEN_TABLE_HEADER = 'asset-open-table-header',
  ASSET_OPEN_LIST = 'asset-open-list',
  ASSET_OPEN_LIST_ITEM = 'asset-open-list-item',
  ASSET_OPEN_LIST_ITEM_ORDER_NO = 'asset-open-list-item-order-no',
  ASSET_OPEN_LIST_ITEM_EXPAND = 'asset-open-list-item-expand',

  ASSET_SPECIFICATION_ITEM_EXPAND = 'asset-specification-item-expand',

  ASSET_HEADER_VIEW_ALL = 'asset-header-view-all',

  ASSET_ORDER_TYPE = 'asset-order-type',
  TAB_ASSET_SPECIFICATION = 'tab-asset-specification',
  TAB_ASSET_ORDER_TYPE_OPEN_POSITIONS = 'tab-asset-order-type-open-positions',
  TAB_ASSET_ORDER_TYPE_PENDING_ORDERS = 'tab-asset-order-type-pending-orders',
  TAB_ASSET_ORDER_TYPE_HISTORY = 'tab-asset-order-type-history',
  TAB_ASSET_ORDER_TYPE_HISTORY_POSITIONS_HISTORY = 'tab-asset-order-type-history-positions-history',
  TAB_ASSET_ORDER_TYPE_HISTORY_ORDERS_AND_DEALS = 'tab-asset-order-type-history-orders-and-deals',

  ASSET_PENDING = 'asset-pending',
  ASSET_PENDING_BUTTON_CLOSE = 'asset-pending-button-close',
  ASSET_PENDING_BUTTON_EDIT = 'asset-pending-button-edit',
  ASSET_PENDING_BUTTON_TRACK = 'asset-pending-button-track',
  ASSET_PENDING_COLUMN_CURRENT_PRICE = 'asset-pending-column-current-price',
  ASSET_PENDING_COLUMN_ENTRY_PRICE = 'asset-pending-column-entry-price',
  ASSET_PENDING_COLUMN_EXPIRY = 'asset-pending-column-expiry',
  ASSET_PENDING_COLUMN_EXPIRY_DATE = 'asset-pending-column-expiry-date',
  ASSET_PENDING_COLUMN_FILL_POLICY = 'asset-pending-column-fill-policy',
  ASSET_PENDING_COLUMN_FILL_VOLUME = 'asset-pending-column-fill-volume',
  ASSET_PENDING_COLUMN_OPEN_DATE = 'asset-pending-column-open-date',
  ASSET_PENDING_COLUMN_SYMBOL = 'asset-pending-column-symbol',
  ASSET_PENDING_COLUMN_TIME_IN_FORCE = 'asset-pending-column-time-in-force',
  ASSET_PENDING_COLUMN_ORDER_ID = 'asset-pending-column-order-id',
  ASSET_PENDING_COLUMN_ORDER_TYPE = 'asset-pending-column-order-type',
  ASSET_PENDING_COLUMN_ORDER_STATUS = 'asset-pending-column-order-status',
  ASSET_PENDING_COLUMN_PENDING_PRICE = 'asset-pending-column-pending-price',
  ASSET_PENDING_COLUMN_STOP_LOSS = 'asset-pending-column-stop-loss',
  ASSET_PENDING_COLUMN_TAKE_PROFIT = 'asset-pending-column-take-profit',
  ASSET_PENDING_COLUMN_STOP_LIMIT_PRICE = 'asset-pending-column-stop-limit-price',
  ASSET_PENDING_COLUMN_LIMIT_PRICE = 'asset-pending-column-limit-price',
  ASSET_PENDING_COLUMN_STOP_PRICE = 'asset-pending-column-stop-price',
  ASSET_PENDING_COLUMN_LAST_PRICE = 'asset-pending-column-last-price',
  ASSET_PENDING_COLUMN_PLACED_QUANTITY = 'asset-pending-column-placed-quantity',
  ASSET_PENDING_COLUMN_FILLED_QUANTITY = 'asset-pending-column-filled-quantity',
  ASSET_PENDING_COLUMN_REMAINING_QUANTITY = 'asset-pending-column-remaining-quantity',
  ASSET_PENDING_COLUMN_UNITS = 'asset-pending-column-units',
  ASSET_PENDING_COLUMN_VOLUME = 'asset-pending-column-volume',
  ASSET_PENDING_TABLE = 'asset-pending-table',
  ASSET_PENDING_TABLE_HEADER = 'asset-pending-table-header',
  ASSET_PENDING_LIST = 'asset-pending-list',
  ASSET_PENDING_LIST_ITEM = 'asset-pending-list-item',
  ASSET_PENDING_LIST_ITEM_EXPAND = 'asset-pending-list-item-expand',
  ASSET_PENDING_LIST_ITEM_ORDER_NO = 'asset-pending-list-item-order-no',

  EDIT_STATIC_ENTRY_PRICE = 'edit-static-entry-price',
  EDIT_STATIC_VOLUME = 'edit-static-volume',
  EDIT_STATIC_UNITS = 'edit-static-units',
  EDIT_SYMBOL_PRICE = 'edit-symbol-price',
  EDIT_INPUT_PRICE = 'edit-input-price',
  EDIT_INPUT_STOP_LIMIT_PRICE = 'edit-input-stop-limit-price',
  EDIT_INPUT_TAKEPROFIT_POINTS = 'edit-input-takeprofit-points',
  EDIT_INPUT_STOPLOSS_POINTS = 'edit-input-stoploss-points',
  EDIT_INPUT_TAKEPROFIT_PRICE = 'edit-input-takeprofit-price',
  EDIT_INPUT_STOPLOSS_PRICE = 'edit-input-stoploss-price',
  EDIT_BUTTON_CANCEL = 'edit-button-cancel',
  EDIT_BUTTON_ORDER = 'edit-button-order',
  EDIT_DROPDOWN_EXPIRY = 'edit-dropdown-expiry',
  EDIT_DROPDOWN_EXPIRY_GOOD_TILL_CANCELLED = 'edit-dropdown-expiry-good-till-cancelled',
  EDIT_DROPDOWN_EXPIRY_GOOD_TILL_DAY = 'edit-dropdown-expiry-good-till-day',
  EDIT_DROPDOWN_EXPIRY_SPECIFIED_DATE = 'edit-dropdown-expiry-specified_date',
  EDIT_DROPDOWN_EXPIRY_SPECIFIED_DATE_AND_TIME = 'edit-dropdown-expiry-specified-date-and-time',
  EDIT_DROPDOWN_FILL_POLICY = 'edit-dropdown-fill-policy',
  EDIT_DROPDOWN_FILL_POLICY_FILL_OR_KILL = 'edit-dropdown-fill-policy-fill-or-kilL',
  EDIT_DROPDOWN_FILL_POLICY_IMMEDIATE_OR_CANCEL = 'edit-dropdown-fill-policy-fill-or-kilL',
  EDIT_DROPDOWN_FILL_POLICY_RETURN = 'edit-dropdown-fill-policy-fill-or-kilL',
  TRADE_DROPDOWN_FILL_POLICY_FILL_OR_KILL = 'trade-dropdown-fill-policy-fill-or-kilL',
  TRADE_DROPDOWN_FILL_POLICY_IMMEDIATE_OR_CANCEL = 'trade-dropdown-fill-policy-fill-or-kilL',
  TRADE_DROPDOWN_FILL_POLICY_RETURN = 'trade-dropdown-fill-policy-fill-or-kilL',
  EDIT_DROPDOWN_DEVIATION = 'edit-dropdown-deviation',

  EDIT_CONFIRMATION_MODAL = 'edit-confirmation-modal',
  EDIT_CONFIRMATION_BUTTON_CONFIRM = 'edit-confirmation-button-confirm',
  EDIT_CONFIRMATION_BUTTON_CLOSE = 'edit-confirmation-button-close',
  EDIT_CONFIRMATION_SYMBOL = 'edit-confirmation-symbol',
  EDIT_CONFIRMATION_ORDER_ID = 'edit-confirmation-order-id',
  EDIT_CONFIRMATION_ORDER_TYPE = 'edit-confirmation-order-type',
  EDIT_CONFIRMATION_LABEL = 'edit-confirmation-label',
  EDIT_CONFIRMATION_VALUE = 'edit-confirmation-value',

  CLOSE_ORDER_BUTTON_SUBMIT = 'close-order-button-submit',
  CLOSE_ORDER_INPUT_VOLUME = 'close-order-input-volume',
  CLOSE_ORDER_INPUT_VOLUME_STATIC_MIN = 'close-order-input-volume-static-min',
  CLOSE_ORDER_INPUT_VOLUME_STATIC_MAX = 'close-order-input-volume-static-max',
  CLOSE_ORDER_BUTTON_CANCEL = 'close-order-button-cancel',
  CLOSE_ORDER_DROPDOWN_FILL_POLICY = 'close-order-dropdown-fill-policy',

  BULK_CLOSE_MODAL_BUTTON_SUBMIT_ALL = 'bulk-close-modal-button-submit-all',
  BULK_CLOSE_MODAL_BUTTON_CANCEL_ALL = 'bulk-close-modal-button-cancel-all',
  BULK_CLOSE_MODAL_BUTTON_CANCEL_LOSS = 'bulk-close-modal-button-cancel-loss',
  BULK_CLOSE_MODAL_BUTTON_CANCEL_PROFIT = 'bulk-close-modal-button-cancel-profit',
  BULK_CLOSE_MODAL_BUTTON_SUBMIT_LOSS = 'bulk-close-modal-button-submit-loss',
  BULK_CLOSE_MODAL_BUTTON_SUBMIT_PROFIT = 'bulk-close-modal-button-submit-profit',
  BULK_DELETE_MODAL_BUTTON_SUBMIT = 'bulk-delete-modal-button-submit',
  BULK_DELETE_MODAL_BUTTON_CANCEL = 'bulk-delete-modal-button-cancel',
  BULK_CLOSE = 'bulk-close',
  BULK_DELETE = 'bulk-delete',
  DROPDOWN_BULK_CLOSE = 'dropdown-bulk-close',
  DROPDOWN_BULK_CLOSE_ALL = 'dropdown-bulk-close-all',
  DROPDOWN_BULK_CLOSE_LOSS = 'dropdown-bulk-close-loss',
  DROPDOWN_BULK_CLOSE_PROFIT = 'dropdown-bulk-close-profit',

  TOGGLE_OCT = 'toggle-oct',
  TOGGLE_OCT_CHECKED = 'toggle-oct-checked',

  TAB_ONE_CLICK_TRADING = 'tab-one-click-trading',
  TAB_TRADE = 'tab-trade',
  TAB_SPECIFICATION = 'tab-specification',

  LANGUAGE_DROPDOWN = 'language-dropdown',
  LANGUAGE_OPTION = 'language-option',

  LOGIN_ACCOUNT_SIGNUP = 'login-account-signup',
  LOGIN_ACCOUNT_TYPE = 'login-account-type',
  LOGIN_PASSWORD = 'login-password',
  LOGIN_SUBMIT = 'login-submit',
  LOGIN_USER_ID = 'login-user-id',
  TAB_LOGIN_ACCOUNT_TYPE_DEMO = 'tab-login-account-type-demo',
  TAB_LOGIN_ACCOUNT_TYPE_LIVE = 'tab-login-account-type-live',
  TAB_LOGIN_ACCOUNT_TYPE_CRM = 'tab-login-account-type-crm',

  NOTIFICATION_BOX = 'notification-box',
  NOTIFICATION_BOX_TITLE = 'notification-box-title',
  NOTIFICATION_BOX_DESCRIPTION = 'notification-box-description',
  NOTIFICATION_BOX_CLOSE = 'notification-box-close',
  NOTIFICATION_DESCRIPTION = 'notification-description',
  NOTIFICATION_DROPDOWN_RESULT = 'notification-dropdown-result',
  NOTIFICATION_LIST_RESULT = 'notification-list-result',
  NOTIFICATION_LIST_RESULT_ITEM = 'notification-list-result-item',
  NOTIFICATION_LIST_RESULT_ITEM_TITLE = 'notification-list-result-item-title',
  NOTIFICATION_LIST_RESULT_ITEM_META = 'notification-list-result-item-meta',
  NOTIFICATION_LIST_RESULT_ITEM_ORDER_NO = 'notification-list-result-item-order-no',
  NOTIFICATION_LIST_RESULT_ITEM_DESCRIPTION = 'notification-list-result-item-description',
  NOTIFICATION_SELECTOR = 'notification-selector',
  NOTIFICATION_TITLE = 'notification-title',
  NOTIFICATION_TYPE = 'notification-type',
  NOTIFICATION_BACK_BUTTON = 'notification-back-button',
  NOTIFICATION_CLOSE_BUTTON = 'notification-close-button',

  NOTIFICATION_ORDER_DETAILS_LABEL = 'notification-order-details-label',
  NOTIFICATION_ORDER_DETAILS_VALUE = 'notification-order-details-value',
  NOTIFICATION_ORDER_DETAILS_MODAL_ORDER_TYPE = 'notification-order-details-modal-order-type',
  NOTIFICATION_ORDER_DETAILS_MODAL_CLOSE = 'notification-order-details-modal-close',
  NOTIFICATION_ORDER_DETAILS_MODAL = 'notification-order-details-modal',

  TAB_NOTIFICATION_TYPE_ORDER = 'tab-notification-type-order',
  TAB_NOTIFICATION_TYPE_SYSTEM = 'tab-notification-type-system',
  TAB_NOTIFICATION_TYPE_INFORMATION = 'tab-notification-type-information',

  CHART_TRADE_BUTTON = 'chart-trade-button',
  CHART_STAR_SYMBOL = 'chart-star-symbol',
  CHART_TOGGLE_FULLSCREEN = 'chart-toggle-fullscreen',
  CHART_EXIT_FULLSCREEN = 'chart-exit-fullscreen',
  CHART_ROOT = 'chart-root',

  SYMBOL_SEARCH_SELECTOR = 'symbol-search-selector',
  SYMBOL_INPUT_SEARCH = 'symbol-input-search',
  SYMBOL_INPUT_SEARCH_CANCEL = 'symbol-input-search-cancel',
  SYMBOL_DROPDOWN_RESULT = 'symbol-dropdown-result',
  SYMBOL_OVERVIEW_ID = 'symbol-overview-id',
  SYMBOL_OVERVIEW_NAME = 'symbol-overview-name',
  SYMBOL_INPUT_SEARCH_ITEMS = 'symbol-input-search-items',
  SYMBOL_INPUT_SEARCH_ITEMS_SYMBOL = 'symbol-input-search-items-symbol',
  SYMBOL_INPUT_SEARCH_ITEMS_DELETE = 'symbol-input-search-items-delete',
  SYMBOL_INPUT_SEARCH_HISTORY = 'symbol-input-search-history',
  SYMBOL_INPUT_SEARCH_HISTORY_DELETE = 'symbol-input-search-history-delete',
  SYMBOL_24HR_LOW = 'symbol-24hr-low',
  SYMBOL_24HR_HIGH = 'symbol-24hr-high',

  TRADE_BUTTON_ORDER_BUY = 'trade-button-order-buy',
  TRADE_BUTTON_ORDER_SELL = 'trade-button-order-sell',
  TRADE_BUTTON_OCT_ORDER_BUY = 'trade-button-oct-order-buy',
  TRADE_BUTTON_OCT_ORDER_SELL = 'trade-button-oct-order-sell',
  TRADE_BOTTOM_SHEET = 'trade-bottom-sheet',
  TRADE_INPUT_VOLUME = 'trade-input-volume',
  TRADE_INPUT_PRICE = 'trade-input-price',
  TRADE_INPUT_STOP_LIMIT_PRICE = 'trade-input-stop-limit-price',
  TRADE_INPUT_TAKEPROFIT_POINTS = 'trade-input-takeprofit-points',
  TRADE_INPUT_STOPLOSS_POINTS = 'trade-input-stoploss-points',
  TRADE_INPUT_TAKEPROFIT_PRICE = 'trade-input-takeprofit-price',
  TRADE_INPUT_STOPLOSS_PRICE = 'trade-input-stoploss-price',
  TRADE_BUTTON_CANCEL = 'trade-button-cancel',
  TRADE_BUTTON_ORDER = 'trade-button-order',
  TRADE_SWAP_TO_UNITS = 'trade-swap-to-units',
  TRADE_SWAP_TO_VOLUME = 'trade-swap-to-volume',
  TRADE_DETAILS = 'trade-details',
  TRADE_DETAILS_TRADE_SIZE = 'trade-details-trade-size',
  TRADE_DETAILS_MARGIN_REQUIRED = 'trade-details-margin-required',
  TRADE_DETAILS_AMOUNT_PER_TICK = 'trade-details-amount-per-tick',
  TRADE_DETAILS_POTENTIAL_GAIN = 'trade-details-potential-gain',
  TRADE_DETAILS_POTENTIAL_LOSS = 'trade-details-potential-loss',
  TRADE_DETAILS_RISK_REWARD = 'trade-details-risk-reward',
  TRADE_DETAILS_PIN_ICON = 'trade-details-pin-icon',
  TRADE_DROPDOWN_EXPIRY = 'trade-dropdown-expiry',
  TRADE_DROPDOWN_EXPIRY_GOOD_TILL_CANCELLED = 'trade-dropdown-expiry-good-till-cancelled',
  TRADE_DROPDOWN_EXPIRY_GOOD_TILL_DAY = 'trade-dropdown-expiry-good-till-day',
  TRADE_DROPDOWN_EXPIRY_SPECIFIED_DATE = 'trade-dropdown-expiry-specified_date',
  TRADE_DROPDOWN_EXPIRY_SPECIFIED_DATE_AND_TIME = 'trade-dropdown-expiry-specified-date-and-time',
  TRADE_DROPDOWN_FILL_POLICY = 'trade-dropdown-fill-policy',
  TRADE_DROPDOWN_DEVIATION = 'trade-dropdown-deviation',
  TRADE_DROPDOWN_ORDER_TYPE = 'trade-dropdown-order-type',
  TRADE_DROPDOWN_ORDER_TYPE_MARKET = 'trade-dropdown-order-type-market',
  TRADE_DROPDOWN_ORDER_TYPE_LIMIT = 'trade-dropdown-order-type-limit',
  TRADE_DROPDOWN_ORDER_TYPE_STOP = 'trade-dropdown-order-type-stop',
  TRADE_DROPDOWN_ORDER_TYPE_STOP_LIMIT = 'trade-dropdown-order-type-stop-limit',
  TRADE_VOLUME_INFO_LABEL = 'trade-volume-info-label',
  TRADE_VOLUME_INFO_VALUE = 'trade-volume-info-value',
  TRADE_VOLUME_INFO_MIN_VALUE = 'trade-volume-info-min-value',
  TRADE_LIVE_BUY_PRICE = 'trade-live-buy-price',
  TRADE_LIVE_SELL_PRICE = 'trade-live-sell-price',
  TRADE_BUTTON_PRE_TRADE_DETAILS = 'trade-button-pre-trade-details',

  TRADE_CONFIRMATION_MODAL = 'trade-confirmation-modal',
  TRADE_CONFIRMATION_BUTTON_CONFIRM = 'trade-confirmation-button-confirm',
  TRADE_CONFIRMATION_BUTTON_CLOSE = 'trade-confirmation-button-close',
  TRADE_CONFIRMATION_SYMBOL = 'trade-confirmation-symbol',
  TRADE_CONFIRMATION_ORDER_TYPE = 'trade-confirmation-order-type',
  TRADE_CONFIRMATION_ORDER_ID = 'trade-confirmation-order-id',
  TRADE_CONFIRMATION_LABEL = 'trade-confirmation-label',
  TRADE_CONFIRMATION_VALUE = 'trade-confirmation-value',

  TRADE_ONE_POINT_EQUAL_LABEL = 'trade-one-point-equal-label',
  EDIT_ONE_POINT_EQUAL_LABEL = 'edit-one-point-equal-label',

  EDIT_INPUT_EXPIRY_DATE = 'edit-input-expiry-date',
  TRADE_INPUT_EXPIRY_DATE = 'trade-input-expiry-date',
  EDIT_INPUT_EXPIRY_TIME = 'edit-input-expiry-time',
  TRADE_INPUT_EXPIRY_TIME = 'trade-input-expiry-time',
  EDIT_INPUT_EXPIRY_TIME_HOUR = 'edit-input-expiry-time-hour',
  TRADE_INPUT_EXPIRY_TIME_HOUR = 'trade-input-expiry-time-hour',
  EDIT_INPUT_EXPIRY_TIME_MINUTE = 'edit-input-expiry-time-minute',
  TRADE_INPUT_EXPIRY_TIME_MINUTE = 'trade-input-expiry-time-minute',
  EDIT_INPUT_EXPIRY_TIME_SECOND = 'edit-input-expiry-time-second',
  TRADE_INPUT_EXPIRY_TIME_SECOND = 'trade-input-expiry-time-second',

  CALENDER_BUTTON_ORDER_HISTORY = 'calender-button-order-history',
  CALENDER_BUTTON_ASSET = 'calender-button-assets',
  CALENDER_BUTTON_ORDER_HISTORY_CONTENT = 'calender-button-order-history-content',
  CALENDER_BUTTON_ASSET_CONTENT = 'calender-button-assets-content',

  OCT_MODAL_BUTTON_CANCEL = 'oct-modal-button-cancel',
  OCT_MODAL_BUTTON_CONFIRM = 'oct-modal-button-confirm',

  ALERT_ERROR = 'alert-error',
  ALERT_SUCCESS = 'alert-success',

  SPECIFICATION_SYMBOL = 'specification-symbol',
  SPECIFICATION_DESCRIPTION = 'specification-description',
  SPECIFICATION_REVENUE = 'specification-revenue',
  SPECIFICATION_TOTAL_ASSETS = 'specification-total-assets',
  SPECIFICATION_OPERATING_INCOME = 'specification-operating-income',
  SPECIFICATION_NET_INCOME = 'specification-net-income',
  SPECIFICATION_TOTAL_EQUITY = 'specification-total-equity',
  SPECIFICATION_MAX_LOT_SIZE = 'specification-max-lot-size',
  SPECIFICATION_MIN_LOT_SIZE = 'specification-min-lot-size',
  SPECIFICATION_LOT_SIZE_STEP = 'specification-lot-size-step',
  SPECIFICATION_POINT_STEP = 'specification-point-step',
  SPECIFICATION_MIN_STOP_DISTANCE = 'specification-min-stop-distance',
  SPECIFICATION_CONTRACT_SIZE = 'specification-contract-size',
  SPECIFICATION_MARGIN_CURRENCY = 'specification-margin-currency',
  SPECIFICATION_MARGIN_HEDGE = 'specification-margin-hedge',
  SPECIFICATION_INITIAL_MARGIN = 'specification-initial-margin',
  SPECIFICATION_MAINTENANCE_MARGIN = 'specification-maintenance-margin',
  SPECIFICATION_SWAP_TYPE = 'specification-swap-type',
  SPECIFICATION_SWAP_LONG = 'specification-swap-long',
  SPECIFICATION_SWAP_SHORT = 'specification-swap-short',
  SPECIFICATION_SWAP_ROLLOVER_3_DAYS = 'specification-swap-rollover-3-days',

  DROPDOWN_CHART_SETTING = 'dropdown-chart-setting',
  DROPDOWN_CHART_SETTING_CHART_COLOR_SETTING = 'dropdown-chart-setting-chart-color-setting',
  DROPDOWN_CHART_SETTING_REMOVE_ALL_DRAWING = 'dropdown-chart-setting-remove-all-drawing',
  DROPDOWN_CHART_SETTING_REMOVE_ALL_INDICATORS = 'dropdown-chart-setting-remove-all-indicators',
  DROPDOWN_CHART_SETTING_RESET_CHART = 'dropdown-chart-setting-reset-chart',
  DROPDOWN_CHART_SETTING_HIDE_ASK_PRICE_ON_Y_AXIS = 'dropdown-chart-setting-hide-ask-price-on-y-axis',
  DROPDOWN_CHART_SETTING_SHOW_ASK_PRICE_ON_Y_AXIS = 'dropdown-chart-setting-show-ask-price-on-y-axis',
  DROPDOWN_CHART_SETTING_CLEAR_ALL_TRACK_DETAILS = 'dropdown-chart-setting-clear-all-track-details',
  DROPDOWN_CHART_SETTING_REMOVE_ALL_INDICATORS_AND_DRAWINGS = 'dropdown-chart-setting-remove-all-indicators-and-drawings',

  CONTEXT_MENU_CHART_SETTING_CHART_COLOR_SETTING = 'context-menu-chart-setting-chart-color-setting',
  CONTEXT_MENU_CHART_SETTING_REMOVE_ALL_DRAWING = 'context-menu-chart-setting-remove-all-drawing',
  CONTEXT_MENU_CHART_SETTING_REMOVE_ALL_INDICATORS = 'context-menu-chart-setting-remove-all-indicators',
  CONTEXT_MENU_CHART_SETTING_REMOVE_ALL_INDICATORS_AND_DRAWINGS = 'context-menu-chart-setting-remove-all-indicators-and-drawings',
  CONTEXT_MENU_CHART_SETTING_HIDE_ASK_PRICE_ON_Y_AXIS = 'context-menu-chart-setting-hide-ask-price-on-y-axis',
  CONTEXT_MENU_CHART_SETTING_SHOW_ASK_PRICE_ON_Y_AXIS = 'context-menu-chart-setting-show-ask-price-on-y-axis',
  CONTEXT_MENU_CHART_SETTING_CLEAR_ALL_TRACK_DETAILS = 'context-menu-chart-setting-clear-all-track-details',
  CONTEXT_MENU_CHART_SETTING_RESET_CHART = 'context-menu-chart-setting-reset-chart',

  CHART_PERIOD_OPTION = 'chart-period-option',
  CHART_TIMEFRAME_DROPDOWN = 'chart-timeframe-dropdown',
  CHART_TIMEFRAME_MINUTES_DROPDOWN = 'chart-timeframe-minutes-dropdown',
  CHART_TIMEFRAME_HOURS_DROPDOWN = 'chart-timeframe-hours-dropdown',
  CHART_TIMEFRAME_DAYS_DROPDOWN = 'chart-timeframe-days-dropdown',

  CHART_INDICATOR = 'chart_indicator',
  CHART_INDICATOR_BUTTON_CLOSE = 'chart-indicator-button-close',
  CHART_INDICATOR_MA = 'chart-indicator-ma',
  CHART_INDICATOR_SD = 'chart-indicator-sd',
  CHART_INDICATOR_SO = 'chart-indicator-so',
  CHART_INDICATOR_ATR = 'chart-indicator-atr',
  CHART_INDICATOR_SAR = 'chart-indicator-sar',
  CHART_INDICATOR_CCI = 'chart-indicator-cci',
  CHART_INDICATOR_RSI = 'chart-indicator-rsi',
  CHART_INDICATOR_BOLL = 'chart-indicator-boll',
  CHART_INDICATOR_MACD = 'chart-indicator-macd',
  CHART_INDICATOR_EMA = 'chart-indicator-ema',
  CHART_INDICATOR_WMA = 'chart-indicator-wma',
  CHART_TRADE_BUTTON_CLOSE = 'chart-trade-button-close',

  SIDE_BAR_OPTION_HOME = 'side-bar-option-home',
  SIDE_BAR_OPTION_TRADE = 'side-bar-option-trade',
  SIDE_BAR_OPTION_MARKETS = 'side-bar-option-markets',
  SIDE_BAR_OPTION_ASSETS = 'side-bar-option-assets',
  SIDE_BAR_OPTION_SIGNAL = 'side-bar-option-signal',
  SIDE_BAR_OPTION_NEWS = 'side-bar-option-news',
  SIDE_BAR_OPTION_CALENDAR = 'side-bar-option-calendar',
  SIDE_BAR_OPTION_COPY_TRADE = 'side-bar-option-copy-trade',
  SIDE_BAR_OPTION_DEALER = 'side-bar-option-dealer',
  SIDE_BAR_OPTION_EDUCATION = 'side-bar-option-education',
  SIDE_BAR_OPTION_INFORMATION = 'side-bar-option-information',

  SPIN_LOADER = 'spin-loader',
  SWITCH_THEME_BUTTON = 'switch-theme-button',

  SETTING_BUTTON = 'setting-button',
  SETTING_OPTION_LINK_SWITCH_TO_LIVE = 'setting-option-switch-to-live',
  SETTING_OPTION_LINK_SWITCH_TO_DEMO = 'setting-option-switch-to-demo',
  SETTING_OPTION_SWITCH_TO_LIVE = 'setting-option-switch-to-live',
  SETTING_OPTION_SWITCH_TO_DEMO = 'setting-option-switch-to-demo',
  SETTING_OPTION_OPEN_DEMO_ACCOUNT = 'setting-option-open-demo-account',
  SETTING_OPTION_NOTIFICATION_SETTING = 'setting-option-notification-setting',
  SETTING_OPTION_LANGUAGE = 'setting-option-language',
  SETTING_OPTION_CHANGE_PASSWORD = 'setting-option-change-password',
  SETTING_OPTION_LINKED_DEVICE = 'setting-option-linked-device',
  SETTING_OPTION_CONTACT_INFORMATION = 'setting-option-contact-information',
  SETTING_OPTION_LOGOUT = 'setting-option-logout',
  SETTING_OPTION_OCT = 'setting-option-oct',
  SETTING_OPTION_APPEARANCE = 'setting-option-appearance',
  SETTING_OPTION_BIOMETRICS_SETTINGS = 'setting-option-biometrics-settings',
  SETTING_OPTION_REQUEST_CANCEL_ACCOUNT = 'setting-option-request-cancel-account',
  SETTING_OPTION_HELP_SUPPORT = 'setting-option-help-support',
  SETTING_OPTION_SUPPORT = 'setting-option-support',
  SETTING_OPTION_ABOUT = 'setting-option-about',
  SETTING_OPTION_PAYMENT_METHOD = 'setting-option-payment-method',

  CANDLESTICK_COLOR_SETTING_MODAL = 'candlestick-color-setting-modal',
  ADS_SKIP_BUTTON = 'ads-skip-button',

  NAVIGATION_BACK_BUTTON = 'navigation-back-button',
  ACTION_SHEET_CANCEL_BUTTON = 'action-sheet-cancel-button',

  FEATURE_ANNOUNCEMENT_MODAL = 'feature-announcement-modal',
  FEATURE_ANNOUNCEMENT_MODAL_GOT_IT_BUTTON = 'feature-announcement-modal-got-it-button',
  FEATURE_ANNOUNCEMENT_MODAL_TRY_IT_NOW_BUTTON = 'feature-announcement-modal-try-it-now-button',
  FEATURE_ANNOUNCEMENT_MODAL_MEDIA_LEFT_BUTTON = 'feature-announcement-modal-media-left-button',
  FEATURE_ANNOUNCEMENT_MODAL_MEDIA_RIGHT_BUTTON = 'feature-announcement-modal-media-right-button',

  CONFIRMATION_MODAL = 'confirmation-modal',
  CONFIRMATION_MODAL_BUTTON_CANCEL = 'confirmation-modal-button-cancel',
  CONFIRMATION_MODAL_BUTTON_SUBMIT = 'confirmation-modal-button-submit',

  ANALYSIS_ACTION_TITLE = 'analysis-action-title',
  ANALYSIS_ACTION_VALUE = 'analysis-action-value',
  ANALYSIS_DESCRIPTION_TITLE = 'analysis-description-title',
  ANALYSIS_DESCRIPTION_VALUE = 'analysis-description-value',

  COPY_TO_ORDER_1 = 'copy-to-order-1',
  COPY_TO_ORDER_2 = 'copy-to-order-2',

  // Signal Screen
  SIGNAL_SCREEN = 'signal-screen',
  SIGNAL_TAB_CONTAINER = 'signal-tab-container',
  SIGNAL_TAB_FAVOURITE = 'signal-tab-favourite',
  SIGNAL_TAB_ALL = 'signal-tab-all',
  SIGNAL_FILTER_FAVOURITE = 'signal-filter-favourite',
  SIGNAL_FILTER_ALL = 'signal-filter-all',

  // Signal List
  SIGNAL_LIST = 'signal-list',
  SIGNAL_LIST_HEADER = 'signal-list-header',
  SIGNAL_LIST_HEADER_MARKETS = 'signal-list-header-markets',
  SIGNAL_LIST_HEADER_STATUS = 'signal-list-header-status',
  SIGNAL_LIST_HEADER_CONFIDENCE = 'signal-list-header-confidence',
  SIGNAL_LIST_HEADER_MODIFIED = 'signal-list-header-modified',
  SIGNAL_LIST_HEADER_PUBLISHED = 'signal-list-header-published',

  // Signal List Item
  SIGNAL_ROW = 'signal-row',
  SIGNAL_ROW_SYMBOL = 'signal-row-symbol',
  SIGNAL_ROW_SYMBOL_NAME = 'signal-row-symbol-name',
  SIGNAL_ROW_SYMBOL_DESCRIPTION = 'signal-row-symbol-description',
  SIGNAL_ROW_SYMBOL_TAG = 'signal-row-symbol-tag',
  SIGNAL_ROW_ORDER_STATUS = 'signal-row-order-status',
  SIGNAL_ROW_CONFIDENCE = 'signal-row-confidence',
  SIGNAL_ROW_MODIFIED_DATE = 'signal-row-modified-date',
  SIGNAL_ROW_PUBLISHED_DATE = 'signal-row-published-date',
  SIGNAL_ROW_STAR = 'signal-row-star',
  SIGNAL_ROW_MARKET_STATUS = 'signal-row-market-status',
  SIGNALS_SYMBOL = 'signals-symbol',

  // Signal Locked Banner
  SIGNAL_LOCKED_BANNER = 'signal-locked-banner',
  SIGNAL_INTEREST_MODAL = 'signal-interest-modal',
  SIGNAL_EXPRESS_INTEREST_BUTTON = 'signal-express-interest-button',

  // Signal Sticky Column
  SIGNAL_STICKY_COLUMN = 'signal-sticky-column',
  SIGNAL_STICKY_COLUMN_ITEM = 'signal-sticky-column-item',

  PORTFOLIO_ROW_STAR = 'portfolio-row-star',
  PORTFOLIO_ROW_SYMBOL = 'portfolio-row-symbol',
  PORTFOLIO_ROW_ORDER_TYPE = 'portfolio-row-order-type',

  TOP_PICKS_STAR = 'top-picks-star',
  TOP_PICKS_SYMBOL = 'top-picks-symbol',
  TOP_GAINER_STAR = 'top-gainer-star',
  TOP_GAINERS_SYMBOL = 'top-gainers-symbol',
  TOP_LOSER_STAR = 'top-loser-star',
  TOP_LOSERS_SYMBOL = 'top-losers-symbol',

  MARKET_SECTION_TITLE = 'market-section-title',
  MARKET_SECTION_TITLE_MORE = 'market-section-title-more',
  MARKET_SECTION_TITLE_MORE_DROPDOWN = 'market-section-title-more-dropdown',
  MARKET_SECTION_TITLE_MORE_DROPDOWN_ITEM = 'market-section-title-more-dropdown-item',
  MARKET_SECTION_SHOW_MORE = 'market-section-show-more',
  MARKET_SECTION_LIST = 'market-section-list',
  WATCHLIST_STAR = 'watchlist-star',
  WATCHLIST_SYMBOL = 'watchlist-symbol',
  WATCHLIST_FILTER = 'watchlist-filter',
  WATCHLIST_FILTER_FAVOURITE = 'watchlist-filter-favourite',
  WATCHLIST_FILTER_ALL = 'watchlist-filter-all',
  WATCHLIST_LIST = 'watchlist-list',
  WATCHLIST_LIST_ITEM = 'watchlist-list-item',
  WATCHLIST_TABS = 'watchlist-tabs',
  MARKET_NEWS_ROW = 'market-news-row',
  MARKET_NEWS_CONTENT_TEXT = 'market-news-content-text',
  MARKET_FAVORITE_SYMBOL = 'favorites-symbol',
  MARKET_MY_POSITIONS_SYMBOL = 'my-positions-symbol',
  MARKET_MY_POSITIONS_TYPE = 'my-positions-type',
  MARKET_MY_POSITIONS_ENTRY_PRICE = 'my-positions-entry-price',
  MARKET_MY_POSITIONS_TAKE_PROFIT = 'my-positions-take-profit',
  MARKET_MY_POSITIONS_PROFIT = 'my-positions-profit',
  MARKET_MY_POSITIONS_PRICE = 'my-positions-price',
  MARKET_MY_POSITIONS_STOP_LOSS = 'my-positions-stop-loss',

  EMPTY_MESSAGE = 'empty-message',
  SYMBOL_PREFERENCE = 'symbol-preference',
  SYMBOL_PREFERENCE_LABEL = 'symbol-preference-label',
  SYMBOL_PREFERENCE_CLOSE = 'symbol-preference-close',
  SYMBOL_PREFERENCE_SEARCH = 'symbol-preference-search',
  SYMBOL_PREFERENCE_OPTIONS = 'symbol-preference-options',
  SYMBOL_PREFERENCE_OPTION = 'symbol-preference-option',
  SYMBOL_PREFERENCE_SELECT_ALL = 'symbol-preference-select-all',
  SYMBOL_PREFERENCE_TABS = 'symbol-preference-tabs',
  SYMBOL_PREFERENCE_SAVE = 'symbol-preference-save',
  SYMBOL_PREFERENCE_CANCEL = 'symbol-preference-cancel',

  FORGOT_PASSWORD_EMAIL_INPUT = 'forgot-password-email-input',
  FORGOT_PASSWORD_ACCOUNT_ID_INPUT = 'forgot-password-account-id-input',
  FORGOT_PASSWORD_NEXT_BUTTON = 'forgot-password-next-button',
  FORGOT_PASSWORD_BACK_TO_LOG_IN = 'forgot-password-back-to-log-in',
  FORGOT_PASSWORD_CONTACT_US = 'forgot-password-contact-us',

  RESET_PASSWORD_EMAIL = 'reset-password-email',
  RESET_PASSWORD_SUBMIT = 'reset-password-submit',
  RESET_PASSWORD_BACK_TO_LOG_IN = 'reset-password-back-to-log-in',

  DEMO_SIGN_UP_NAME_INPUT = 'demo-sign-up-name-input',
  DEMO_SIGN_UP_EMAIL_INPUT = 'demo-sign-up-email-input',
  DEMO_SIGN_UP_NUMBER_SELECTOR = 'demo-sign-up-number-selector',
  DEMO_SIGN_UP_NUMBER_INPUT = 'demo-sign-up-number-input',
  DEMO_SIGN_UP_DEPOSIT_SELECTOR = 'demo-sign-up-deposit-selector',
  DEMO_SIGN_UP_AGREE_AND_CONTINUE = 'demo-sign-up-agree-and-continue',
  DEMO_SIGN_UP_BACK_LOG_IN = 'demo-sign-up-back-log-in',

  SIGN_UP_EMAIL_INPUT = 'sign-up-email-input',
  SIGN_UP_PASSWORD_INPUT = 'sign-up-password-input',
  SIGN_UP_ACCOUNT_TYPE = 'sign-up-account-type',
  SIGN_UP_ACCOUNT_TYPE_DROPDOWN_LIST = 'sign-up-account-type-dropdown-list',
  SIGN_UP_ACCOUNT_TYPE_ITEM = 'sign-up-account-type-item',
  SIGN_UP_COUNTRY_DROPDOWN = 'sign-up-countr-dropdown',
  SIGN_UP_COUNTRY_SELECTOR = 'sign-up-country-selector',
  SIGN_UP_COUNTRY_LIST = 'sign-up-country-list',
  SIGN_UP_COUNTRY_SEARCH_INPUT = 'sign-up-country-search-input',
  SIGN_UP_COUNTRY_OPTION = 'sign-up-country-option',
  SIGN_UP_ACKNOWLEDGE_CHECKED = 'sign-up-acknowledge-checked',
  SIGN_UP_ACKNOWLEDGE_UNCHECKED = 'sign-up-acknowledge-unchecked',
  TNC = 'tnc',
  PRIVACY_POLICY = 'privacy-policy',
  RISK_DISCLOSURE = 'risk-disclosure',
  SIGN_UP_BASIC_CONTINUE = 'sign-up-basic-continue',
  SIGN_UP_RESEND_VERIFICATION = 'sign-up-resend-verification',
  SIGN_UP_VERIFICATION_BUTTON = 'sign-up-verification-button',
  SIGN_UP_COMPLETE_BUTTON = 'sign-up-complete-button',

  NEWS_OPTION = 'news-option',
  ACCOUNT_SELECTOR = 'account-selector',
  ACCOUNT_INFO = 'account-info',
  ACCOUNT_INFO_STOP_OUT_LEVEL = 'account-info-stop-out-level',
  ACCOUNT_INFO_MARGIN_CALL_LEVEL = 'account-info-margin-call-level',
  ACCOUNT_INFO_DROPDOWN = 'account-info-dropdown',
  ACCOUNT_INFO_DROPDOWN_ICON = 'account-info-dropdown-icon',
  ACCOUNT_NAME = 'account-name',
  ACCOUNT_ID = 'account-id',
  ACCOUNT_DETAIL = 'account-detail',
  ACCOUNT_TYPE_TAG = 'account-type-tag',
  ACCOUNT_TOTAL_BALANCE = 'account-total-balance',
  ACCOUNT_OPTION_ITEM = 'account-option-item',
  ACCOUNT_OPTION_NAME = 'account-option-name',
  ACCOUNT_OPTION_DETAIL = 'account-option-detail',
  ACCOUNT_OPTION_BALANCE = 'account-option-balance',
  ADD_ACCOUNT = 'add-account',
  LINK_ACCOUNT_MODAL = 'link-account-modal',
  LINK_ACCOUNT_MODAL_CLOSE = 'link-account-modal-close',
  LINK_ACCOUNT_MODAL_CONFIRM = 'link-account-modal-confirm',
  LINK_ACCOUNT_MODAL_TITLE = 'link-account-modal-title',
  LINK_ACCOUNT_MODAL_ACCOUNT_ID = 'link-account-modal-account-id',
  LINK_ACCOUNT_MODAL_PASSWORD = 'link-account-modal-password',
  LINK_SWITCH_CONFIRMATION_MODAL = 'link-switch-confirmation-modal',
  LINK_SWITCH_CONFIRMATION_MODAL_CLOSE = 'link-switch-confirmation-modal-close',
  LINK_SWITCH_CONFIRMATION_MODAL_CONFIRM = 'link-switch-confirmation-modal-confirm',
  LINK_SWITCH_CONFIRMATION_MODAL_TITLE = 'link-switch-confirmation-modal-title',
  LINK_SWITCH_CONFIRMATION_MODAL_DESCRIPTION = 'link-switch-confirmation-modal-description',
  CHANGE_PASSWORD_MODAL = 'change-password-modal',
  CHANGE_PASSWORD_MODAL_CLOSE = 'change-password-modal-close',
  CHANGE_PASSWORD_MODAL_CONFIRM = 'change-password-modal-confirm',
  CHANGE_PASSWORD_MODAL_TITLE = 'change-password-modal-title',
  CHANGE_PASSWORD_MODAL_OLD_PASSWORD = 'change-password-modal-old-password',
  CHANGE_PASSWORD_MODAL_NEW_PASSWORD = 'change-password-modal-new-password',
  CHANGE_PASSWORD_MODAL_CONFIRM_NEW_PASSWORD = 'change-password-modal-confirm-new-password',
  DEMO_ACCOUNT_CREATION_MODAL = 'demo-account-creation-modal',
  DEMO_ACCOUNT_CREATION_MODAL_CLOSE = 'demo-account-creation-modal-close',
  DEMO_ACCOUNT_CREATION_MODAL_CONFIRM = 'demo-account-creation-modal-confirm',
  DEMO_ACCOUNT_CREATION_MODAL_TITLE = 'demo-account-creation-modal-title',
  DEMO_ACCOUNT_CREATION_MODAL_NAME = 'demo-account-creation-modal-name',
  DEMO_ACCOUNT_CREATION_MODAL_EMAIL = 'demo-account-creation-modal-email',
  DEMO_ACCOUNT_CREATION_MODAL_PHONE = 'demo-account-creation-modal-phone',
  DEMO_ACCOUNT_CREATION_MODAL_DEPOSIT = 'demo-account-creation-modal-deposit',
  DEMO_ACCOUNT_CREATION_MODAL_AGREEMENT = 'demo-account-creation-modal-agreement',
  INPUT_FIELD_VALIDATION = 'input-field-validation',
  COUNTRY_DIAL_CODE_DROPDOWN = 'country-dial-code-dropdown',
  COUNTRY_DIAL_CODE_ITEM = 'country-dial-code-item',
  COUNTRY_DIAL_CODE_LIST = 'country-dial-code-list',
  COUNTRY_DIAL_CODE = 'country-dial-code',
  COUNTRY_DIAL_CODE_SEARCH = 'country-dial-code-search',
  DEPOSIT_DROPDOWN_ITEM = 'deposit-dropdown-item',
  DEPOSIT_DROPDOWN_LIST = 'deposit-dropdown-list',
  DEMO_ACCOUNT_COMPLETION_MODAL = 'demo-account-completion-modal',
  DEMO_ACCOUNT_COMPLETION_MODAL_TITLE = 'demo-account-completion-modal-title',
  DEMO_ACCOUNT_COMPLETION_MODAL_SIGN_IN = 'demo-account-completion-modal-sign-in',
  DEMO_COMPLETION_LABEL = 'demo-completion-label',
  DEMO_COMPLETION_VALUE = 'demo-completion-value',
  PAGINATION_NEXT = 'pagination-next',
  PAGINATION_PREV = 'pagination-prev',
  RESET_PASSWORD_LINK = 'reset-password-link',
  COLUMN_PREFERENCE = 'column-preference',
  ORDER_SORT_SELECTOR = 'order-sort-selector',
  ORDER_SORT_OPTIONS = 'order-sort-options',
  SORT_OPTION_ITEM = 'sort-option-item',
  ORDER_COLUMN_PREFERENCE_MODAL = 'order-column-preference-modal',
  ORDER_COLUMN_PREFERENCE_MODAL_CLOSE = 'order-column-preference-modal-close',
  ORDER_COLUMN_PREFERENCE_MODAL_TITLE = 'order-column-preference-modal-title',
  ORDER_COLUMN_PREFERENCE_MODAL_SAVE = 'order-column-preference-modal-save',
  ORDER_COLUMN_PREFERENCE_MODAL_CANCEL = 'order-column-preference-modal-cancel',
  ORDER_COLUMN_PREFERENCE_MODAL_SELECT_ALL = 'order-column-preference-modal-select-all',
  ORDER_COLUMN_PREFERENCE_MODAL_ITEM = 'order-column-preference-modal-item'
}
